import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../store/action/language/language"; // ✅ your original import
import { useTranslation } from "react-i18next";
import langicon from "../Images/langicon.svg";
import { FaChevronDown } from "react-icons/fa";


export default function LanguageSelector({
    currentLang,
    borderColor = "#E57200",
    options = [
        { code: "en", label: "EN", dir: "ltr" },
        { code: "ar", label: "AR", dir: "rtl" },
        { code: "id", label: "ID", dir: "ltr" },
        { code: "ur", label: "UR", dir: "rtl" },
    ],
}) {
    const [menuVisible, setMenuVisible] = useState(false);
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const languageState = useSelector((state) => state.language);

    const toggleMenu = () => setMenuVisible((prev) => !prev);

    const handleSelect = (lang, dir) => {
        // update translation immediately
        i18n.changeLanguage(lang);

        // update redux store using your original action
        dispatch(setLanguage(lang, dir));

        // persist to localStorage
        localStorage.setItem("appLanguage", JSON.stringify({ lang, dir }));

        // set direction
        document.getElementById("root").style.direction = dir;
        i18n.changeLanguage(lang);
       
      

        // close dropdown
        setMenuVisible(false);
    };

    return (
        <div className="relative z-[150]">
            {/* Trigger */}
            <div
                onClick={toggleMenu}
                style={{ border: `1.5px solid #E3E4E9`, borderRadius: "1rem" }}
                className="bg-white w-fit gap-2  flex flex-row items-center justify-start  p-2 cursor-pointer hover:bg-gray-100"
            >
                {langicon && <img src={langicon} alt="language" />}
                <div className="text-stone-700 font-cairo text-sm font-semibold leading-tight">
                    {(() => {
                        const lang = (currentLang || languageState.lang || "en").toLowerCase();
                        switch (lang) {
                            case "ar":
                                return "العربية";
                            case "en":
                                return "English";
                            case "id":
                                return "Indonesia";
                            case "ur":
                                return "اردو";
                            default:
                                return lang.toUpperCase();
                        }
                    })()}
                </div>
                <FaChevronDown size={18} className="text-gray-600" />
            </div>

            {/* Dropdown */}
            {menuVisible && (
                <div className="absolute mt-2 w-20 bg-white border border-gray-200 rounded-xl shadow-lg z-[150]">
                    {options.map((opt) => (
                        <button
                            key={opt.code}
                            onClick={() => handleSelect(opt.code, opt.dir)}
                            className={`w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${(languageState.lang || currentLang || "en") === opt.code
                                ? "bg-gray-100 font-bold"
                                : ""
                                }`}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}